import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { PersonPointDialogComponent } from 'app/dialogs/person-point-dialog/person-point-dialog.component';
import { AuthService } from 'app/services/auth.service';
import { PersonPointService } from 'app/services/models/person-point.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-point-list',
  templateUrl: './point-list.component.html',
  styleUrls: ['./point-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PointListComponent implements OnInit {
  @Input() personId: number;
  constructor(
    private pointPersonService: PersonPointService,
    private modalService: NgbModal,
    public formatter: NgbDateParserFormatter,
    private calendar: NgbCalendar,
    private datePipe: DatePipe,
    public authService: AuthService
  ) { }

  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any;
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption: number = 5;
  public searchValue = '';
  totalCount: Number = 0;
  public ColumnMode = ColumnMode;

  startFilterDate?: string | null = null;
  endFilterDate?: string | null = null;


  async ngOnInit() {
    this.pointPersonService.event$.subscribe(async result => {
      await this.getPersonPoints(this.pageBasic - 1, this.selectedSize, this.searchValue, this.personId, this.startFilterDate, this.endFilterDate);
    })
    await this.getPersonPoints(this.pageBasic - 1, this.selectedSize, this.searchValue, this.personId, this.startFilterDate, this.endFilterDate);
  }

  async getPersonPoints(page, size, search, personId, startDate?: string, endDate?: string) {
    this.blockUI.start("Puantaj yükleniyor..");
    const pointsAuthorization = this.authService.isEndpointStatus('GET.Reading.GetAllPersonByIdPoints');
    if (pointsAuthorization) {
      const data = await this.pointPersonService.getPersonPoints(page, size, search, personId, startDate, endDate);
      console.log(data);
      this.rows = data.points;
      this.totalCount = data.totalCount;
    }
    this.blockUI.stop();
  }

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.searchValue = val;
    setTimeout(async () => {

      await this.getPersonPoints(this.pageBasic - 1, this.selectedSize, this.searchValue, this.personId, this.startFilterDate, this.endFilterDate);
    }, 500);
  }

  async onPageChange(pageNumber: number) {
    await this.getPersonPoints(this.pageBasic - 1, this.selectedSize, this.searchValue, this.personId, this.startFilterDate, this.endFilterDate);
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption)
    await this.getPersonPoints(this.pageBasic - 1, this.selectedSize, this.searchValue, this.personId, this.startFilterDate, this.endFilterDate);
  }

  getStatusText(status: number): string {
    switch (status) {
      case 1:
        return 'Normal Mesai';
      case 2:
        return 'Eksik Mesai';
      case 3:
        return 'Fazla Mesai';
      case 4:
        return 'Resmi Tatil'
      default:
        return 'Bilinmeyen Durum';
    }
  }

  getBadgeClass(status: number): string {
    switch (status) {
      case 1:
        return 'badge badge-pill badge-info';
      case 2:
        return 'badge badge-pill badge-danger';
      case 3:
        return 'badge badge-pill badge-success';
      case 4:
        return 'badge badge-pill badge-warning';
      default:
        return 'badge badge-pill badge-secondary'; // Bilinmeyen durum
    }
  }

  createPersonPoint() {
    const modal = this.modalService.open(PersonPointDialogComponent, {
      size: 'sm',
      centered: true,
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      personId: this.personId,
      row: null
    };
  }

  updatePersonPoint(row) {
    const modal = this.modalService.open(PersonPointDialogComponent, {
      size: 'sm',
      centered: true,
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      personId: this.personId,
      row: row
    };
  }

  public hoveredDate: NgbDate | null = null;
  public fromDate: NgbDate | null;
  public toDate: NgbDate | null;


  /**
 * Range selection Date Picker
 *
 * @param date
 */
  async onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }

    const startDateFormatted = this.formatDate2(this.fromDate);
    const endDateFormatted = this.formatDate2(this.toDate);

    console.log('Start Date:', startDateFormatted ? startDateFormatted : 'Not selected');
    console.log('End Date:', endDateFormatted ? endDateFormatted : 'Not selected');

    this.startFilterDate = (startDateFormatted).toString();
    this.endFilterDate = (endDateFormatted).toString();

    await this.getPersonPoints(this.pageBasic - 1, this.selectedSize, this.searchValue, this.personId, this.startFilterDate, this.endFilterDate);


  }

  formatDate2(date: NgbDate): string | null {
    if (!date) return null;

    // Convert NgbDate to JavaScript Date object
    const jsDate = new Date(date.year, date.month - 1, date.day);

    // Format the date using DatePipe
    return this.datePipe.transform(jsDate, 'yyyy-MM-dd');
  }

  /**
   * Is Hovered
   *
   * @param date
   */
  isHovered(date: NgbDate) {
    return (
      this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
    );
  }

  /**
   * Is Inside
   *
   * @param date
   */
  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  /**
   *  Is Range
   *
   * @param date
   */
  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  displayDateRange(): string {
    if (this.fromDate && this.toDate) {
      return `${this.formatter.format(this.fromDate)} - ${this.formatter.format(this.toDate)}`;
    } else if (this.fromDate) {
      return this.formatter.format(this.fromDate);
    }
    return '';
  }
}
